import { render } from "./CompaniesListItem.vue?vue&type=template&id=fb58c502"
import script from "./CompaniesListItem.vue?vue&type=script&lang=js"
export * from "./CompaniesListItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__